import { render, staticRenderFns } from "./DocumentsCard.vue?vue&type=template&id=a301960e&scoped=true"
import script from "./DocumentsCard.vue?vue&type=script&lang=js"
export * from "./DocumentsCard.vue?vue&type=script&lang=js"
import style0 from "./DocumentsCard.vue?vue&type=style&index=0&id=a301960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a301960e",
  null
  
)

export default component.exports